import countryConfigHelper from '$lib/helpers/country-config-helper';

export function match(param: string) {
  const sitemapLanguages = countryConfigHelper.getAvailableLocales().map((locale) => locale.split('-')[0]);

  return sitemapLanguages.includes(param);
}
